import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Container,
  Input,
  Box,
  InputAdornment,
  IconButton,
  CircularProgress,
  Backdrop
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/styles';
import CreateIcon from '@material-ui/icons/Create';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import moment from 'moment';
import Controls from '../controls/Controls';

import { useConstantsContext } from '../../context/constants_context';
import { useClientContext } from '../../context/client_context';
import { useDocumentsContext } from '../../context/document_context';
import {
  baseUrl,
  gender,
  maritalState,
  titles,
  memberStatuses,
  memberTypes,
  relationShips,
  suffixes
} from '../../utils/constants';
import DependantSub from './DependantSub';
import DependantsDocs2 from '../dependants/DependantsDocs2';
import DependantsGlo from './DependentsGlo';
import DocumentsMain from './DocumentsMain';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    }
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  color: {
    backgroundColor: '#f5f5f5'
  },
  newButton: {
    position: 'absolute',
    right: '10px'
  }
}));

export default function DocumentsAdd() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { towns, suburbs, banks, bankBranches } = useConstantsContext();
  const { currDependant, setClientRefId, setDependant, setCurrentClient } = useClientContext();
  const { setMainDocs, populateMainDocuments } = useDocumentsContext();
  const [memberSearchName, setSearchName] = useState('');
  const [memberCode, setMemberCode] = useState('');
  const [operation, setOperation] = useState('save');
  const [loading, setLoading] = useState(false);
  const [isMain, setMain] = useState(true);
  const [isDisabled, setDisabled] = useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: ''
  });

  const PersonalDetailsSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(2, 'First Name is too Short!')
      .max(50, 'First Name is too Long!')
      .required('First name required'),
    surname: Yup.string()
      .min(2, 'Surname is too Short!')
      .max(50, 'Surname is too Long!')
      .required('Last name required'),
    idNumber: Yup.string().required('ID Number or Birth Cert is requied or other'),
    title_id: Yup.string().required('Title of Member required'),
    dateOfBirth: Yup.date().required('Date Of Birth required'),
    suffix: Yup.string().required('Suffix is required'),
    maritalStatus: Yup.string().required('Marital Status is required'),
    memberType_ID: Yup.string().required('Member Type is required'),
    relationship_ID: Yup.string().required('Relation to main member is required')
  });

  useEffect(() => {
    // getDependantById();
    // setFormData(initialValue);
  }, []);

  const formik = useFormik({
    initialValues: currDependant,
    enableReinitialize: true,
    validationSchema: PersonalDetailsSchema,
    onSubmit: (values) => {
      console.log('dependant 2', values);
      //   if (!values.parent_cif || values.parent_cif === -1) values.parent_cif = clientRefId;
      saveClientData(values);
    }
  });

  currDependant.dateOfBirth = moment(currDependant.dateOfBirth).format('yyyy-MM-DD');
  // setMemberNo(currDependant.memberShipNo);
  currDependant.membershipStartDate = moment(currDependant.membershipStartDate).format(
    'yyyy-MM-DD'
  );
  if (currDependant.termdate)
    currDependant.termdate = moment(currDependant.termdate).format('yyyy-MM-DD');
  const date1 = moment(currDependant.dateOfBirth);
  const date2 = moment();
  const diff = date2.diff(date1, 'years');
  currDependant.age = diff;

  const saveClientData = (client) => {
    const jsonClient = [];
    jsonClient.push(client);
    console.log('dependant stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/client/SaveDependant`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('returned dependant', result);
          setDependant(result);
          notifyPopup(`Dependant changes saved successfully!`, 'success');
        },
        (error) => {
          notifyPopup(
            `Error in Saving Dependant Changes, Changes not effected!: ${error}`,
            'error'
          );
        }
      );
  };

  const getMemberInfo = async () => {
    if (memberCode === '') {
      notifyPopup(`No Employee # Selected, please enter number to search for!`, 'error');
      return;
    }
    setLoading(true);
    await axios(`${baseUrl}/api/client/GetMembersByFundNo?medFundNo=${memberCode}`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Provider not Found!: ${result.replyMessage}`, 'error');
        } else {
          console.log('returned parentRef', result.data.result[0].cif_number);
          console.log('returned members cif', result.data.result[0]);
          setCurrentClient(result.data.result[0]);
          // setDependant(result.data.result[0]);
          formik.setFieldValue('surname', '');
          formik.setFieldValue('firstName', '');
          formik.setFieldValue('idNumber', '');
          formik.setFieldValue('cif_number', 0);
          formik.setFieldValue('title_id', '');
          formik.setFieldValue('sex_ID', 0);
          formik.setFieldValue('age', 0);
          formik.setFieldValue('suffix', '');
          formik.setFieldValue('dependents', 0);
          formik.setFieldValue('maritalStatus', '');
          formik.setFieldValue('memberType_ID', '');
          formik.setFieldValue('dateOfBirth', '');
          formik.setFieldValue('relationship_ID', '');
          formik.setFieldValue('membershipStartDate', moment().format('yyyy-MM-DD'));
          setSearchName(`${result.data.result[0].surname} ${result.data.result[0].firstName}`);
          setClientRefId(result.data.result[0].cif_number);
          setMainDocs([]);
          populateMainDocuments(result.data.result[0].cif_number);
        }
      },
      (error) => {
        notifyPopup(`Error in getMemberInfo!: ${error}`, 'error');
      }
    );
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const { errors, touched, getFieldProps } = formik;

  return (
    <Container>
      <Card>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
          onClick={handleLoadingClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <CardContent>
          <FormikProvider value={formik}>
            <Grid container spacing={2} direction="row">
              <Grid item xs={3} sm={3} mr={2}>
                <FormControl>
                  <InputLabel htmlFor="memberCodem">Search Members</InputLabel>
                  <Input
                    id="memberCode"
                    type="text"
                    value={memberCode}
                    onChange={(e) => {
                      setMemberCode(e.target.value);
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onMouseDown={handleMouseDownPassword}
                          onClick={() => getMemberInfo()}
                        >
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel htmlFor="memberSearchName">Member Name</InputLabel>
                  <Input id="memberSearchName" type="text" value={memberSearchName} disabled />
                </FormControl>
              </Grid>
            </Grid>
            <Form autoComplete="off" noValidate>
              <Grid
                margin={2}
                container
                direction="row"
                justifyContent="space-between"
                alignItems="right"
              >
                {/* <Grid item xs={12} sm={3} marginRight={6}>
                  <Typography component="span" variant="h6" gutterBottom>
                    Add Dependant
                  </Typography>
                  <Button
                    type="button"
                    sx={{ color: '#0c5935' }}
                    variant="outlined"
                    disabled={isDisabled}
                    startIcon={<CreateIcon />}
                    onClick={() => clearCache()}
                  >
                    New...
                  </Button>
                </Grid> */}
                {/* <Grid item xs={12} sm={1} marginRight={3}>
                  <Button
                    type="submit"
                    variant="outlined"
                    disabled={isDisabled}
                    startIcon={<ThumbUpIcon />}
                    onClick={() => setOperation('save')}
                  >
                    Save...
                  </Button>
                </Grid> */}
              </Grid>
              {/* <Grid container spacing={2} justifyContent="center" alignItems="center">
                <Grid item xs={12} sm={2}>
                  <Controls.SelectJson name="title_id" label="Title" options={titles} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Controls.Input name="firstName" label="First Name" />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.Input name="surname" label="Last Name" />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Controls.SelectJson
                    name="memberType_ID"
                    label="Member Type"
                    options={memberTypes}
                  />
                </Grid>
                <Grid item xs={12} sm={1}>
                  <Controls.Input name="cif_number" label="Ref Id" disabled />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.SelectJson name="suffix" label="Suffix" options={suffixes} />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.Input name="idNumber" label="Id Number" />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.DateTime name="dateOfBirth" label="Date Of Birth" />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.SelectJson name="sex_ID" label="Gender" options={gender} />
                </Grid>
                <Grid item xs={12} sm={3} paddingBottom={2}>
                  <Controls.SelectJson
                    name="maritalStatus"
                    label="Marital Status"
                    options={maritalState}
                  />
                </Grid>
                <Grid item xs={12} sm={3} paddingBottom={2}>
                  <Controls.SelectJson
                    name="relationship_ID"
                    label="Relationship to Member"
                    options={relationShips}
                  />
                </Grid>
                <Grid item xs={12} sm={3} paddingBottom={2}>
                  <Controls.SelectJson
                    name="memberStatus"
                    label="Member Status"
                    options={memberStatuses}
                  />
                </Grid>
                <Grid item xs={12} sm={3} paddingBottom={2}>
                  <Controls.DateTime name="membershipStartDate" label="Membership Start Date" />
                </Grid>
              </Grid> */}
            </Form>
            {/* <Box sx={{ ml: 3, my: 1 }}>
              <Typography variant="h6">Existing Documents...</Typography>
            </Box> */}
            <DocumentsMain />
            <Controls.Notification notify={notify} setNotify={setNotify} />
          </FormikProvider>

          <Controls.ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
        </CardContent>
      </Card>
    </Container>
  );
}
